/*
 * Angular 2 decorators and services
 */
import { Component, ViewEncapsulation, OnInit, AfterViewInit, ElementRef, HostListener } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, NavigationStart, ResolveEnd, ResolveStart, GuardsCheckEnd } from '@angular/router';
import { AlertService, SharedService, ApiService } from './common/service';
import { LocalStorageService } from 'angular-2-local-storage';
import { TranslateService } from '@ngx-translate/core';

import { AppState } from './app.service';
import { AppConfig } from './app.config';
import { Observable, Subscription } from 'rxjs';

import * as moment from 'moment';
import * as adblockDetect from 'adblock-detect';

import * as _ from 'lodash';
// import { Body } from '@angular/http/src/body';
import Pace from 'pace-js'

declare let jQuery;

// tslint:disable: component-class-suffix

/*
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  encapsulation: ViewEncapsulation.None,
  // styles: [
  //   require('./scss/application.scss')
  // ],
  template: `<router-outlet></router-outlet>`
})
export class App implements OnInit, AfterViewInit {
  paused = false;
  constructor(
    public appState: AppState,
    public translate: TranslateService,
    public appConfig: AppConfig,
    public window: Window,
    // public sharedService: SharedService,
    public router: Router,
    public route: ActivatedRoute,
    public storage: LocalStorageService,
    public alertService: AlertService,
    public sharedService: SharedService,
    public api: ApiService,
    public el: ElementRef
  ) {
    // console.log('AppComponent -> sharedService', _.cloneDeep(this.sharedService))
    this.window['adblockDetect'] = adblockDetect;
    window['$'] = window['jQuery'] = jQuery;
  }


  @HostListener('window:scroll', ['$event'],)
  onScroll() {
    // var btn = document.createElement("div");
    //btn.id='swipeMsg';

    //document.body.appendChild(btn);
    // let node = '<div id="swipeMsg"><div class="text-center h5"> <img src="/assets/img/swipe-helper-W.gif"/><p>swipe left to see other metrics</p></div></div>';
    //console.log(node);
    //let div = document.createElement("div");
    //div.setAttribute("id", "swipeMsg");
    //document.getElementById('swipeMsg').innerHTML='<div class="text-center h5"> <img src="/assets/img/swipe-helper-W.gif"/><p>swipe left to see other metrics</p></div>';
    //document.body.appendChild(div);


    /* if (this.isInViewport(visibility) && this.paused == false) {
       document.getElementById("swipeMsg").style.display = 'flex'
       this.paused=true; 
     }
     else {
         document.getElementById("swipeMsg").style.display = 'none'
      
     }*/
  }

  isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
  }


  public ngOnInit() {
    
    
    // const Pace = window['Pace'];
    Pace.options.ajax.trackMethods = ['GET', 'POST', 'DELETE', 'PUT', 'PATCH'];
    Pace.options.ajax.ignoreURLs = [
      // /^.*\.css(v['1-9']{1,}(\.['1-9']{1,3}){2}\-[0-9]{9})?$/,
      // /.*(google(tagmanager|\-analytics)?|facebook|linkedin|sockjs|data\:).*/i,
      // // /.*(braintree\-api|cardinalcommerce|kaptcha).*/i,
      // /.*(regional(\-cdn)?\.bksn\.se).*/i,
      // /.*(websocket).*/i,
      // /.*(\/assets\/)?.*\.(png|jpe?g|woff)/i,
      // /.*\/api\/.*(service|wallet|news\/?\?feed\=1)/i,
      /^((?!\/api\/)|\/api\/.*(service|wallet|news\/?\?feed\=1)).*$/i,
      /^.*\/api\/ext\/adobe\/.*$/i,
    ];
    // Pace.options.ajax.restartOnRequestAfter = false;
    // Pace.options.ajax.restartOnPushState = false;
    Pace.options.ajax.trackWebSockets = false;
    Pace.options.document = false;
    Pace.options.eventLag = false;
    // Pace.options.ghostTime = 100;
    // Pace.options.maxProgressPerFrame = 20;
    // Pace.options.elements = false;
    Pace.on('start', () => { jQuery('div.pace-mask').show(); });
    Pace.on('done', () => { jQuery('div.pace-mask').hide(); });

    let observer$;
    const regexTesterUser = /^(qa|developer)$/;
    this.window['__startTesterSession'] = (user: string, ttl?: number) => {
      if (!regexTesterUser.test(user)) {
        return console.warn('invalid tester user');
      }
      if (this.storage.get<string>('x-tester-user') !== user) {
        if (observer$ instanceof Subscription) { observer$.unsubscribe(); observer$ = null; }
        this.storage.set('x-tester-user', user);
        this.storage.set('x-tester-expire-time', (new Date()).getTime() + ((ttl || 3600) * 1000)); // 1 hour left by default
        this.alertService.info({
          timer: 5000,
          title: 'Starting Tester Session...',
          html: 'Your tester session expires at <br />' + moment(this.storage.get<number>('x-tester-expire-time')).format(),
          useRejections: false
        }).then(() => this.window.location.href = '/login');
      }

      if (!(observer$ instanceof Subscription)) {
        observer$ = Observable.interval(5000).subscribe(() => {
          if (this.storage.get<number>('x-tester-expire-time') <= (new Date()).getTime()) {
            // console.log('TESTER SESSION EXPIRED!');
            this.storage.clearAll();
            observer$.unsubscribe();
            this.alertService.info({
              timer: 5000,
              title: 'Your tester session is expired!',
              useRejections: false
            })
              .then(() =>
                this.window.location.href = '/login');
          }
          // console.log('TESTER SESSION IS STILL VALID!');
        });

      }
    };

    // const regexSettingsUser = /^(mgallelli|aenciso)$/;
    // this.window['__settingsToogle'] = (user: string, ttl: number = (60 * 60)) => {
    //   if (!regexSettingsUser.test(user)) {
    //     return console.warn('invalid user');
    //   }

    //   const Messenger = window['Messenger']();

    //   this.storage.set('x-setting-enabled', true);
    //   // this.storage.set('x-setting-expire', (new Date()).getTime() + ((ttl || 3600) * 1000));
    //   this.storage.set('x-setting-expire', (new Date()).getTime() + ((ttl || 3600) * 1000));
    //   const $o = Observable.interval(5000).subscribe(() => {
    //     // console.log(this.route);
    //     if (this.storage.get<number>('x-setting-time') <= (new Date()).getTime()) {
    //       $o.unsubscribe();
    //       const msg = Messenger.post({
    //         message: 'Settings Disabled',
    //         actions: {
    //           gotit: {
    //             label: 'Reactivate', action: () => {
    //               this.window['__settingsToogle'](user); window['Messenger']().hideAll(); return { action: false };
    //             }
    //           },
    //           cancel: {
    //             label: 'Cancel', action: () => {
    //               this.storage.remove('x-setting-enabled', 'x-setting-expire'); this.router.navigate(['/']); window['Messenger']().hideAll(); return { action: false };
    //             }
    //           }
    //         },
    //       });
    //     }
    //   });

    //   window['Messenger'].options = {
    //     extraClasses: 'messenger-fixed messenger-on-bottom messenger-on-right',
    //     theme: 'air'
    //   };
    //   const msg = window['Messenger']().post({
    //     message: 'Settings Enabled',
    //     actions: { gotit: { label: 'Got It!', action: () => { this.router.navigate(['/settings']), window['Messenger']().hideAll(); } } }
    //   });
    //   setTimeout(() => this.router.navigate(['/settings']), 5000);

    // };

    // remove sponsorship variables
    const clearSponsorshipVars = () => {
      this.storage.remove('tax_fee');
      this.storage.remove('x-advertiser-impersonate');
    }
    clearSponsorshipVars();
    this.router.events.skip(1).subscribe((e) => {
      if (e instanceof NavigationStart) { clearSponsorshipVars(); }
    })


    this.route.queryParams.subscribe((q) => {
      if (!/^\/(login|signup|resetpass|forgot|error|logout|confirmation).*/i.test(this.window.location.pathname.trim())) {
        const search = {};
        const qs = this.window.location.search
          .slice(1) // remove initial ?
          .split('&') // split key pairs
          .filter((v) => !!v.trim())
          .map((v) => {
            const [field, val] = v.split('=');
            search[decodeURIComponent(field)] = decodeURIComponent(val); // save into search object
          });
        this.storage.remove('redir-path', 'redir-search');
        this.storage.set('redir-path', this.window.location.pathname);
        // tslint:disable-next-line:curly
        if (qs.length > 0)
          this.storage.set('redir-search', JSON.stringify(search));
      }
      if (q.__tester || this.storage.get<string>('x-tester-user')) {
        this.window['__startTesterSession'](q.__tester || this.storage.get<string>('x-tester-user')); // 1 hour left
      }
    });

    this.window['adblockDetect']((detected: boolean) => {
      if (detected) {
        this.alertService.error({ html: 'ERROR.ADBLOCK_DETECTED', useRejections: false });
      }
    }, { testInterval: 40, testRuns: 5 });

  }

  public ngAfterViewInit() {
 
    jQuery(this.el.nativeElement).attr('version', VERSION.full);

    this.router.events
      // .filter((e) => (e instanceof NavigationEnd || e instanceof NavigationStart))
      .subscribe((e) => {
        if (e instanceof NavigationEnd && this.router.url !== this.storage.get<string>('current-url')) {
          this.storage.set('previous-url', _.cloneDeep(this.storage.get<string>('current-url')));
          this.storage.set('current-url', e['url']);
        }

        
      });
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/app.component.ts